<template>
  <div>
    <template v-if="mode === 'fields'">
      <!-- 手動入力フィールド（AI自動入力でないテンプレート用） -->
      <div class="edit-form-item" v-if="!showAiCard">
        <div class="item-name">役職・部署名</div>
        <div class="item-body">
          <el-input class="input-md" placeholder="" title="役職・部署名"
            v-model="basicData.yakushokuBusho"></el-input>
        </div>
        <div class="item-name">業種</div>
        <div class="item-body">
          <el-select v-model="basicData.gyoushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in industryData" :key="group.igCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">職種</div>
        <div class="item-body">
          <el-select v-model="basicData.shokushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in jobTypeData" :key="group.jgCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">希望業種</div>
        <div class="item-body">
          <el-select v-model="basicData.kibouGyoushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in industryData" :key="group.igCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">希望職種</div>
        <div class="item-body">
          <el-select v-model="basicData.kibouShokushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in jobTypeData" :key="group.jgCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>

      <!-- 現在の業界・職種（AI志望動機と共有） -->
      <div class="edit-form-item" v-if="formatId === 'rirekisho_job_change'">
        <div class="item-name">現在のあなたのいる業界</div>
        <div class="item-body">
          <el-select v-model="formatData.currentIndustrycategory" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option v-for="item in hopeIndustryOptions" :key="item" :label="item || '未選択'" :value="item"></el-option>
          </el-select>
        </div>
        <div class="item-name">現在のあなたのいる職種</div>
        <div class="item-body">
          <el-select v-model="formatData.currentJobcategory" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option v-for="item in hopeCareerJobcategoryOptions" :key="item" :label="item || '未選択'" :value="item"></el-option>
          </el-select>
        </div>
      </div>

      <!-- 年収フィールド -->
      <div class="edit-form-item">
        <div class="item-name">現在の年収</div>
        <div class="item-body">
          <el-select v-model="formatData.nowNensyu" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option label="399万円以下" value="399万円以下"></el-option>
            <el-option label="400万円以上" value="400万円以上"></el-option>
            <el-option label="700万円以上" value="700万円以上"></el-option>
          </el-select>
        </div>
        <div class="item-name">希望年収</div>
        <div class="item-body">
          <el-input class="input-xs" placeholder="" title="希望年収" type="number"
            v-model="formatData.kibouNensyu"></el-input> 万円
        </div>
      </div>
      <div class="item-name" style="font-size: 0.8rem;">※上記項目を入力した後、例文から追加ボタンをクリックして例文を選択すると自動的に反映されます。</div>
    </template>

    <template v-if="mode === 'ai-card'">
      <!-- AI自動入力 編集モーダル -->
      <modal v-if="showAiCard" name="request-edit-dialog" :adaptive="true" :scrollable="true" height="auto">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('request-edit-dialog');" icon="el-icon-close" type="text"></el-button>
        </div>
        <div class="title">職種などの編集</div>
        <div class="description" style="padding: 16px;">
          <div class="edit-form-item">
            <div class="item-name">役職・部署名</div>
            <div class="item-body">
              <el-input class="input-md" placeholder="役職・部署名" v-model="basicData.yakushokuBusho"></el-input>
            </div>
            <div class="item-name">業種</div>
            <div class="item-body">
              <el-select v-model="basicData.gyoushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachIndustryGroups" :key="group.igCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="item-name">職種</div>
            <div class="item-body">
              <el-select v-model="basicData.shokushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachJobCategoryGroups" :key="group.jgCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="item-name">希望業種</div>
            <div class="item-body">
              <el-select v-model="basicData.kibouGyoushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachIndustryGroups" :key="group.igCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="item-name">希望職種</div>
            <div class="item-body">
              <el-select v-model="basicData.kibouShokushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachJobCategoryGroups" :key="group.jgCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
        </div>
        <div class="text-right" style="padding: 16px;">
          <el-button @click="$modal.hide('request-edit-dialog');">閉じる</el-button>
        </div>
      </modal>

      <!-- AI自動入力カード -->
      <div v-if="showAiCard" style="margin-top: 16px;">
        <div v-if="requestAiLoading" class="text-center" style="padding: 20px;">
          <i class="el-icon-loading" style="font-size: 24px;"></i>
          <p style="margin-top: 8px; color: #909399;">AIが入力データを分析中...</p>
        </div>
        <div v-else-if="requestAiError" style="padding: 12px; background: #fef0f0; border-radius: 4px; margin-bottom: 12px;">
          <p style="color: #f56c6c; margin: 0;">{{ requestAiError }}</p>
        </div>
        <div v-else-if="requestAiGenerated">
          <div style="background: #f5f7fa; border-radius: 4px; padding: 12px;">
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">役職・部署名:</span> <span>{{ basicData.yakushokuBusho || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">業種:</span> <span>{{ getIndustryName(basicData.gyoushuCd) || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">職種:</span> <span>{{ getJobCategoryName(basicData.shokushuCd) || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">希望業種:</span> <span>{{ getIndustryName(basicData.kibouGyoushuCd) || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">希望職種:</span> <span>{{ getJobCategoryName(basicData.kibouShokushuCd) || '(未設定)' }}</span></div>
            <div style="text-align: right;">
              <el-button size="small" type="danger" @click="$modal.show('request-edit-dialog')">編集</el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PersonalRequestFields',
  props: {
    mode: {
      type: String,
      default: 'fields',
      validator: function (value) {
        return ['fields', 'ai-card'].indexOf(value) !== -1
      }
    },
    formatData: {
      type: Object,
      required: true
    },
    basicData: {
      type: Object,
      required: true
    },
    formatId: {
      type: String,
      required: true
    },
    industryData: {
      type: Array,
      required: true
    },
    jobTypeData: {
      type: Array,
      required: true
    },
    showAiCard: {
      type: Boolean,
      default: false
    },
    requestAiGenerated: {
      type: Boolean,
      default: false
    },
    requestAiLoading: {
      type: Boolean,
      default: false
    },
    requestAiError: {
      type: String,
      default: ''
    },
    bizreachIndustryGroups: {
      type: Array,
      default: () => []
    },
    bizreachJobCategoryGroups: {
      type: Array,
      default: () => []
    },
    getIndustryName: {
      type: Function,
      default: () => () => ''
    },
    getJobCategoryName: {
      type: Function,
      default: () => () => ''
    }
  },
  mounted() {
    // Vue 2 では未定義キーへの代入が非リアクティブになるため、新規 current 系フィールドを $set で初期化
    if (!('currentIndustrycategory' in this.formatData)) {
      this.$set(this.formatData, 'currentIndustrycategory', '')
    }
    if (!('currentJobcategory' in this.formatData)) {
      this.$set(this.formatData, 'currentJobcategory', '')
    }
  },
  data() {
    return {
      hopeIndustryOptions: ['', 'IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeCareerJobcategoryOptions: ['', '営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業']
    }
  }
}
</script>
